
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormularzSrodka from '../components/FormularzSrodka';
import { apiFetch } from '../services/api';

export default function DodajSrodek(){
  const nav=useNavigate();
  const zapisz=async payload=>{
    const data=await apiFetch('/srodki-trwale',{method:'POST',body:JSON.stringify(payload)});
    nav(`/srodki-trwale/${data.id_srodka}`);
  };
  return <FormularzSrodka onZapisz={zapisz} onAnuluj={()=>nav('/srodki-trwale')}/>;
}
